import { vatNumberPL, vatNumberPT } from "@lib/validators/regex/general";
import { string } from "yup";
import type { DeliveryStepFormErrorHeaders } from "../deliveryStepValidationSchema";
import type { CountryCode } from "@config/site/types";

export const getVatValidation = (
    countryCode: CountryCode,
    headers: DeliveryStepFormErrorHeaders,
    { excludeEmptyString = false }: { excludeEmptyString?: boolean } = {}
) => {
    switch (countryCode) {
        case "PL":
            return string().matches(vatNumberPL, {
                message: headers.vatNumber,
                excludeEmptyString,
            });

        case "PT":
            return string().matches(vatNumberPT, {
                message: headers.vatNumber,
                excludeEmptyString,
            });

        default:
            return string();
    }
};
